import axios from "axios";
import { USER_DATA_AND_CHATBOT_COLLECTION } from "constants/global/firebase-collections";
import { deleteField, doc, updateDoc } from "firebase/firestore";
import { fbGraphApi } from "functions/facebookAds";
import store from "store";

export const getFbPages = (tokenFromParam: string, userId: string, getBusinesses?: boolean) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(
        `https://api.plai.io/fb_ig_ads/get_facebook_pages`,
        {
          accessToken: tokenFromParam,
          userId,
          message: "getFbPages",
          getBusinesses,
        }
      );

      console.log(response, "response of fb pages");

      if (response?.data?.results?.accounts?.data?.length) {
        const publishedPages = response?.data?.results?.accounts?.data.filter(
          (page: any) => page.is_published
        );
        resolve(publishedPages);
      } else {
        resolve([]);
      }
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
};

export const getInstaAccs = (item: any = {}) => {
  const { id, access_token } = item;
  console.log(item, "fb item");

  const { originalUserData = {} }: any = store.getState().appReducer;
  const { lastSelectedWorkspace = {} } = originalUserData;
  const { workspaceId } = lastSelectedWorkspace;

  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await axios.post(
        `https://api.plai.io/fb_ig_ads/get_instagram_pages`,
        {
          facebookPageId: id,
          pageAccessToken: access_token,
        }
      );
      console.log(data, "data insta acc 1");
      if (!data?.success) {
        reject(data?.errormessage);
      } else {
        if (!data.results?.data?.length) {
          const docRef = doc(USER_DATA_AND_CHATBOT_COLLECTION, workspaceId);
          updateDoc(docRef, {
            lastSelectedInstaAcc: deleteField(),
          });
        }
        resolve(data.results?.data);
      }
    } catch (error) {
      console.log(error, "insta acc error");
    }
  });
};

export const getPageAccessToken = async (pageId: string) => {
  try {
    const response: any = await fbGraphApi(pageId, null, "access_token");
    if (response?.access_token) {
      return response.access_token;
    }
  } catch (error) {
    console.log(error, "page access token error.");
  }
};

export const getFbBusinessManagers = async (tokenFromParam: string) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(
        `https://api.plai.io/fb_ig_ads/get_business_managers`,
        {
          accessToken: tokenFromParam,
        }
      );

      console.log(response, "response of fb pages");

      if (response?.data?.results?.businesses) {
        resolve(response?.data?.results?.businesses);
      } else {
        resolve([]);
      }
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
};

export const createFbBusinessManager = async (data: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(
        `https://api.plai.io/fb_ig_ads/create_business_manager`,
        data
      );

      console.log(response, "response of create fb manager");

      if (response?.data?.success) {
        resolve(true);
      } else {
        resolve(false);
      }
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
};
export const createFbAsset = async (data: any) => {
  try {
    const response = await axios.post(
      `https://api.plai.io/fb_ig_ads/create_ad_account`,
      data
    );

    console.log(response, "response of create fb asset");

    return response.data.results;
  } catch (error: any) {
    console.log(error);
    return error.response.data.results;
  }
};

export const getBusinessConnectionStatus = async (data: any) => {
  try {
    const response = await axios.post(
      `https://api.plai.io/fb_ig_ads/get_business_connection_status`,
      data
    );

    console.log(response, "response of business creation status");

    if (response?.data?.success) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.log(error);
    return false;
  }
};